import React, { useState } from "react";
import { DashboardApi } from "../../../../../../core/api/dashboardApi";
import CustomModal from "../../../../../../layout/components/customModal";
import RenderSvg from "../../../../../../layout/components/icons/RenderSvg";
import "./style.scss";
import { TrackedItemsVariables } from "../../../../../../core/constants/TrackedItemsConstants";
const AIDrivenActionsComponentWatchlist = ({ record, navigateToWatchlistDashboard, }) => {
    const [AIData, setAIData] = useState(undefined);
    const [visible, setVisible] = useState(false);
    const handleAIAnalysis = (record) => {
        DashboardApi.getAIDashboardResponse(record.itemId).then((response) => {
            setAIData(response);
            setVisible(true);
        }).catch((error) => {
            setVisible(true);
        });
    };
    const handleViewMore = (record) => {
        navigateToWatchlistDashboard(record);
    };
    const onClose = () => {
        setVisible(false);
        setAIData(undefined);
    };
    const isTrackedItemAIAnalysis = record.itemCategoryId === TrackedItemsVariables.FinancialCategoryCode && record.systemCreated === false;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ai-driven-actions" }, isTrackedItemAIAnalysis && (React.createElement("div", { className: "ai-actions-group-2" },
            React.createElement(RenderSvg, { icon: "RodaAiGlass", onClick: () => handleAIAnalysis(record), style: { cursor: "pointer" } })))),
        React.createElement(CustomModal, { visible: visible, onCancel: onClose, maskClosable: false, destroyOnClose: true, footer: null, title: ["AI Analysis"], width: "50%" },
            React.createElement("div", { style: { paddingLeft: "7px" } },
                React.createElement("h4", { style: {
                        color: "#000000",
                        fontSize: "14px",
                        fontWeight: 700,
                        marginBottom: '10px'
                    } }, "Root Cause Analysis"),
                React.createElement("p", null, (() => {
                    var _a, _b;
                    // Check if analysis has not run yet
                    if (!(AIData === null || AIData === void 0 ? void 0 : AIData.latest_month) && !(AIData === null || AIData === void 0 ? void 0 : AIData.latest_year)) {
                        return 'The AI analysis will be generated once the latest data is ingested.';
                    }
                    // Check if status is 1 or 4 (report not found)
                    if ((AIData === null || AIData === void 0 ? void 0 : AIData.status) === 1 || (AIData === null || AIData === void 0 ? void 0 : AIData.status) === 4) {
                        return 'AI Analysis could not be performed for this KPI.';
                    }
                    if ((AIData === null || AIData === void 0 ? void 0 : AIData.status) === undefined || (AIData === null || AIData === void 0 ? void 0 : AIData.status) === null) {
                        return 'No Root Cause Analysis performed, as the KPI is not at risk.';
                    }
                    // Default case: show root cause if it exists
                    return ((_b = (_a = AIData === null || AIData === void 0 ? void 0 : AIData.analysis_report) === null || _a === void 0 ? void 0 : _a.json_report) === null || _b === void 0 ? void 0 : _b.root_cause) || 'No Root Cause Analysis available.';
                })())),
            React.createElement("div", { style: {
                    textAlign: "center",
                    marginTop: '20px',
                    marginBottom: '10px',
                    // backgroundColor: "#ECF8F7" 
                } },
                React.createElement("button", { style: {
                        color: "#00B2B2",
                        fontWeight: 600,
                        fontSize: 13,
                        // textDecoration: "underline",
                        lineHeight: "20px",
                        letterSpacing: "0.2px",
                        cursor: "pointer",
                        minHeight: "20px",
                        borderRadius: "2px",
                        border: "none",
                        background: "none",
                        padding: 0,
                        width: "100%"
                    }, onClick: () => handleViewMore(record) }, "View More")))));
};
export default AIDrivenActionsComponentWatchlist;
